import React from 'react';
import { CmdbFieldObjectPicker } from '@atlassian/jira-servicedesk-cmdb-field-object-picker';
import {
	MAX_CMDB_OBJECTS_PER_FIELD,
	LimitData,
} from '@atlassian/jira-servicedesk-common/src/ui/components/limit-data';
import { withFormField, FieldContainer } from '../../common/ui';
import { closeMenuOnScroll } from '../../common/utils/select';
import type { Props, CmdbFieldConfig, FieldValue } from './types';

const CmdbField = (props: Props) => {
	const {
		autoCompleteUrl,
		additionalData: { isMulti = false, attributesIncludedInAutoCompleteSearch },
		fieldProps: { value, onChange },
		contextAndValuesOfIssueBeingCreated,
		selectedProject,
		autoFocus = false,
		width,
		fieldId,
	} = props;

	return (
		<FieldContainer width={width}>
			<LimitData limitProperty={MAX_CMDB_OBJECTS_PER_FIELD}>
				{(limit) => (
					<CmdbFieldObjectPicker
						autoCompleteUrl={`${autoCompleteUrl}?`}
						displayedValues={value}
						selectedValues={value}
						attributesToDisplayInSearch={attributesIncludedInAutoCompleteSearch}
						multiple={isMulti}
						onChange={onChange}
						autoFocus={autoFocus}
						limit={limit}
						menuPosition="fixed"
						onCloseMenuOnScroll={closeMenuOnScroll}
						contextAndValuesOfIssueBeingCreated={{
							...contextAndValuesOfIssueBeingCreated,
							fieldId,
							selectedProject,
						}}
					/>
				)}
			</LimitData>
		</FieldContainer>
	);
};

// @ts-expect-error - TS2345 - Argument of type '(props: Props) => JSX.Element' is not assignable to parameter of type 'AbstractComponent<ComponentProps<CmdbFieldConfig, FieldValue>, any>'.
export default withFormField({})<CmdbFieldConfig, FieldValue>(CmdbField);
